import type { RootState } from 'types'

const wishlistList = (state: RootState) => state.wishlist.wishList
const basketList = (state: RootState) => state.wishlist.basket
const informationList = (state: RootState) => state.wishlist.information

export const WishlistSelectors = {
  basketList,
  wishlistList,
  informationList,
}
